import * as api from '../../services/tax/apiTaxCode';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { getLocalDateOnly } from '../../utils/local_date';


export function* deleteTaxCodeSaga(feathersApp) {
  yield takeEvery('DELETE_TAXCODE', callDeleteTaxCode, feathersApp);
}

export function* deleteTaxCodeFromListSaga(feathersApp) {
  yield takeEvery('DELETE_TAXCODE_FROM_LIST', callDeleteTaxCodeFromList, feathersApp);
}

export function* fetchListTaxCodeSaga(feathersApp) {
  yield takeLatest('FETCH_LIST_TAXCODE', callFetchListTaxCode, feathersApp);
}

export function* fetchTaxCodeForEditSaga(feathersApp) {
  yield takeEvery('FETCH_TAXCODE_FOR_EDIT', callFetchTaxCodeForEdit, feathersApp);
}

export function* saveTaxCodeSaga(feathersApp) {
  yield takeEvery("SAVE_TAXCODE", callSaveTaxCode, feathersApp);
}


function* callFetchListTaxCode(feathersApp, action) {
  const { silent, filters } = action;
  yield common.showProgressListTable(silent);
  try {

    const { available_from, available_to } = filters;
    const dataParams = { 
      filters: {
        ...filters,
        available_from: getLocalDateOnly(available_from),
        available_to: getLocalDateOnly(available_to),
      },
      list_type: 'tax_code'
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total});
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

function* callDeleteTaxCodeFromList(feathersApp, action) {
  yield deleteTaxCode(feathersApp, action);
  yield delay(2000); 
  yield callFetchListTaxCode(feathersApp, { silent: true });
}


function* callDeleteTaxCode(feathersApp, action) {
  const result = yield deleteTaxCode(feathersApp, action);
  yield delay(2000); 
  if (result) {
    browserHistory.push('/admin/tax_code');
  }
}

function* deleteTaxCode(feathersApp, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const { tenant, user } = yield select();
      const { id } = action;
      const params = { tenant, user, id };
      result = yield call(api.deleteTaxCode, feathersApp, params);
      yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.TAX_CODE } });
      yield delay(2000); 
      yield callFetchListTaxCode(feathersApp, { silent: true });
    }
    return result;
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error })
  }
}



function* callSaveTaxCode(feathersApp, action) {
  const { tenant, user } = yield select();
  try {
    yield put({ type: 'SAVE_RECORD_INPROGRESS' });

    const params = { tenant, user, data: action.data };
    let result = yield call(api.saveTaxCode, feathersApp, params);
    const id = result && result.id;
    yield callFetchTaxCodeForEdit(feathersApp, { id, silent: true });
    browserHistory.push(`/admin/tax_code/edit/${id}`);
    yield common.doneSaveRecord(result, 'Tax Code was saved');
  } catch (e) {
    yield common.showErrorSaveRecord(e);
  }

}

function* callFetchTaxCodeForEdit(feathersApp, action) {
  const { tenant, user } = yield select();
  const { id, silent } = action;
  try {
    if (id) {
      yield common.showProgressDataById(silent);
      const fetchParams = { tenant, user, id };
      const doc = yield call(api.fetchTaxCodeById, feathersApp, fetchParams);
      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
  }
}
